import { links } from 'bzx-common/src/config/appConfig'
import { observer } from 'mobx-react'
import React from 'react'
import { NavLink } from 'react-router-dom'
import ExternalLink from 'shared-components/ExternalLink'
import { Icon } from 'ui-framework'
import DashboardVM from '../DashboardVM'
import AppUpdates from './AppUpdates'
import BestAPR from './BestAPR'
import BlogPosts from './BlogPosts'
import LobbyDao from './LobbyDao'
import webPreview from '../../../../public/ooki-web-preview.png'
import Twitter from './Twitter'

const ookiIcon = <Icon name="token-ooki" />
const bzrxIcon = <Icon name="token-bzrx" />

export function Lobby({ vm }: { vm: DashboardVM }) {
  return (
    <>
      <div className="lobby">
        <div className="lobby__intro panel--simple pos-rel overflow-hidden">
          <div className="flex-col height-100p">
            <img src={webPreview} className="lobby__video-placeholder" />
            {/* <iframe
              className="block"
              width="100%"
              height="100%"
              src={links.videos.ookiPromo}
              title="OOKI - Intro"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            /> */}
            <div className="flex-col-end">
              <div className="grid-2-col txt-center">
                <ExternalLink
                  className="btn btn--medium btn--menu flex-center"
                  href={links.gitbook}>
                  FAQ
                </ExternalLink>
                <ExternalLink
                  className="btn btn--medium btn--menu flex-center"
                  href={links.blog.url}>
                  Blog
                </ExternalLink>
              </div>
            </div>
          </div>
        </div>
        <div>
          <NavLink
            to="/token-migration"
            className="btn btn--blue btn--small-corners flex-center margin-bottom-1">
            <div className="margin-right-1">Migrate to Ooki Token</div>
            {bzrxIcon} {ookiIcon}
          </NavLink>
          <Twitter vm={vm} />
        </div>

        <BestAPR vm={vm} />
        <LobbyDao vm={vm} />
        <BlogPosts blogStore={vm.rootStore.blogStore} />
        <AppUpdates vm={vm} />
      </div>
    </>
  )
}

export default observer(Lobby)
